<% var component = new Anvil.models.components.Form(...params) %>
<form anvil-component="<%- component.id %>" id="<%= component.name %>_form" class="form-horizontal">
	<% for (let field of fields) { %>
		<%- include('form/' + field.type, { form: component, field }) %>
	<% } %>
</form>
